import {
  DEPARTMENT_GROUP_PREVIEW,
  DEPARTMENT_GROUP_NEW,
  DEPARTMENT_GROUP_UPDATE,
  DEPARTMENT_GROUP_REMOVE,
  DEPARTMENT_GROUP_PROCESS_SUCCESS,
  DEPARTMENT_GROUP_DATASOURCE_SUCCESS,
  DEPARTMENT_GROUP_SEARCH,
  DEPARTMENT_GROUP_PROCESS_RESET
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEPARTMENT_GROUP_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case DEPARTMENT_GROUP_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case DEPARTMENT_GROUP_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case DEPARTMENT_GROUP_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case DEPARTMENT_GROUP_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case DEPARTMENT_GROUP_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case DEPARTMENT_GROUP_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case DEPARTMENT_GROUP_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}